(() => {
  'use strict';
  const card=document.querySelector('[data-noise-card]');
  if(!card)return;
  const presets=Array.from(card.querySelectorAll('[data-shot-preset]'));
  const countInput=card.querySelector('[data-shot-count]');
  const secondsInput=card.querySelector('[data-shot-seconds]');
  const put=(name,text)=>{card.querySelector('[data-'+name+']').textContent=text;};
  const numeric=new Intl.NumberFormat('en-US',{maximumFractionDigits:1});
  // Meinke et al. 2014, Tables 1-4: standing youth-ear-position means.
  // L_Aeq8 is already integrated single-shot energy, NOT the peak SPL.
  // Normalize equal energy to 85 dBA/8h; do not multiply peak dB by session time.
  const perShot=gun=>100*Math.pow(10,(Number(gun.dataset.energy)-85)/10);
  const topOfScale=value=>{
    const target=Math.max(200,value*1.12), power=Math.pow(10,Math.floor(Math.log10(target)));
    return [1,2,5,10].find(step=>step*power>=target)*power;
  };
  const paint=(announce=false)=>{
    const gun=presets.find(input=>input.checked)||presets.find(input=>input.value==='3006');
    const shots=Math.min(20,Math.max(1,Math.round(Number(countInput.value)||5)));
    const seconds=Math.min(120,Math.max(10,Number(secondsInput.value)||30));
    // Fixed comparison examples, excluding the selected firearm to avoid duplicate lines.
    const comparisons=['22','12ga','3006'].filter(id=>id!==gun.value).slice(0,2).map(id=>presets.find(input=>input.value===id));
    const series=[['low',comparisons[0]],['selected',gun],['high',comparisons[1]]];
    // Hold the height constant while shot count/time change: more shots visibly climb.
    const yMax=topOfScale(Math.max(...series.map(([,item])=>perShot(item)*20)));
    const y=value=>219-184*value/yMax;
    // Equal-energy occupational reference, not an impulse-noise injury threshold.
    const referenceY=y(100);
    card.querySelector('[data-dose-reference]').setAttribute('d','M46 '+referenceY.toFixed(2)+'H420');
    card.querySelector('[data-dose-reference-label]').setAttribute('y',(referenceY-8).toFixed(2));
    put('shot-peak',gun.dataset.peak);put('shot-model',gun.dataset.model);
    put('shot-setup',gun.dataset.barrel+' · '+gun.dataset.ammo);
    // Only the peak is measured. This schematic has no calibrated time axis.
    const peak=Number(gun.dataset.peak),peakY=242-(peak-80)*2.1;
    const pulse='M46 242H132L158 225L166 '+peakY.toFixed(2)+'L175 '+(peakY+27).toFixed(2)+'L194 '+(peakY+91).toFixed(2)+'Q218 219 270 236L330 242H420';
    card.querySelector('[data-impulse-line]').setAttribute('d',pulse);
    card.querySelector('[data-impulse-area]').setAttribute('d',pulse+'V242Z');
    card.querySelector('[data-impulse-dot]').setAttribute('cy',peakY.toFixed(2));
    card.querySelector('[data-impulse-peak-label]').setAttribute('y',(peakY-16).toFixed(2));
    put('impulse-caliber',gun.dataset.label+' · measured peak');
    put('impulse-peak',numeric.format(peak)+' dB');
    put('impulse-peak-label',numeric.format(peak)+' dB');
    put('impulse-over','+'+numeric.format(peak-140)+' dB');
    put('impulse-takeaway','Even one '+gun.dataset.label+' shot peaks above this line.');
    const impulseSummary='One '+gun.dataset.label+' shot peaks at '+numeric.format(peak)+' dB SPL in the study, '+numeric.format(peak-140)+' dB above the 140 dB peak reference. The pulse shape and duration are illustrative, not a recorded waveform.';
    put('impulse-description',impulseSummary);
    put('shot-count-value',shots+(shots===1?' shot':' shots'));put('shot-seconds-value',seconds+' sec');
    countInput.setAttribute('aria-valuetext',shots+(shots===1?' shot':' shots'));
    secondsInput.setAttribute('aria-valuetext',seconds+' seconds');
    put('dose-mid-time','60s');put('dose-end-time','120s');
    const baseline=perShot(presets.find(input=>input.value==='22'));
    for(const [name,item] of series){
      const increment=perShot(item);
      let path='M46 219';
      for(let shot=1;shot<=shots;shot++)path+='H'+(46+374*(seconds/120)*shot/shots).toFixed(2)+'V'+y(increment*shot).toFixed(2);
      path+='H420';
      card.querySelector('[data-dose-line="'+name+'"]').setAttribute('d',path);
      put('dose-'+name+'-label',item.dataset.label);put('dose-'+name+'-total',numeric.format(increment/baseline)+'×');
      if(name==='selected'){
        card.querySelector('[data-dose-dot]').setAttribute('cy',y(increment*shots).toFixed(2));
        card.querySelector('[data-dose-dot]').setAttribute('cx',(46+374*seconds/120).toFixed(2));
      }
    }
    const shotWord=shots===1?'shot':'shots';
    put('dose-session-title',shots+' '+gun.dataset.label+' '+shotWord+'. Every one adds exposure.');
    put('dose-session-explainer','The orange line is your '+gun.dataset.label+'. Follow it from left to right: each jump adds one shot, then the line stays flat after the last shot.');
    put('shot-session','Last shot at '+seconds+' seconds. The flat section means no additional shots—not that earlier exposure has gone away.');
    put('dose-dot-label',shots+' '+shotWord);
    const dotX=46+374*seconds/120,dotY=y(perShot(gun)*shots);
    const marker=card.querySelector('[data-dose-dot-label]');
    marker.setAttribute('x',Math.min(414,Math.max(92,dotX)).toFixed(2));
    marker.setAttribute('y',Math.max(23,dotY-13).toFixed(2));
    marker.setAttribute('text-anchor',dotX>350?'end':'middle');
    put('dose-comparison-caption','Same '+shots+' '+shotWord+' for every caliber below');
    const ratio=numeric.format(perShot(gun)/baseline);
    put('dose-takeaway-title',gun.value==='22'?'.22 LR is the comparison starting point.':gun.dataset.label+': about '+ratio+'× the exposure of .22 LR.');
    put('dose-copy',gun.value==='22'?'The other lines show how the same number of shots from different firearms can add much more noise exposure. Lower exposure still calls for hearing protection.':'In these measurements, '+shots+' '+gun.dataset.label+' '+shotWord+' add about '+ratio+' times the noise exposure of '+shots+' .22 LR '+shotWord+'. This compares exposure, not how many times louder a shot sounds.');
    const summary=shots+' '+gun.dataset.label+' '+shotWord+' over '+seconds+' seconds. Orange is your selection. Each jump is one shot; higher lines mean more total noise exposure. '+series.map(([,item])=>item.dataset.label+': '+numeric.format(perShot(item)/baseline)+' times the exposure of .22 LR for the same number of shots').join('; ')+'. A flat line means no additional shots. These study examples do not predict hearing damage or safe shot counts.';
    const referenceNote=' The red dashed line is the daily noise benchmark: an equal-energy comparison with 85 dBA over eight hours. Gunshots can pose a hearing risk below this line too.';
    put('dose-description',summary+referenceNote);
    if(announce)put('dose-status',summary+referenceNote+' '+impulseSummary);
  };
  presets.forEach(input=>input.addEventListener('change',()=>paint(true)));
  for(const input of [countInput,secondsInput]){
    input.addEventListener('input',()=>paint());
    input.addEventListener('change',()=>paint(true));
  }
  paint();
})();
